import { render, staticRenderFns } from "./CardAdminCandidatos.vue?vue&type=template&id=39754074&scoped=true"
import script from "./CardAdminCandidatos.vue?vue&type=script&lang=js"
export * from "./CardAdminCandidatos.vue?vue&type=script&lang=js"
import style0 from "./CardAdminCandidatos.vue?vue&type=style&index=0&id=39754074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39754074",
  null
  
)

export default component.exports